export enum SpecialDemand {
  Buildings = 'building',
  LocalWaterGrid = 'localWaterGrid',
  OtherProvidersElectricity = 'otherProvidersElectricity',
}
